@if (visible()) {
  <nav
    class="fixed bottom-0 left-0 right-0 z-50 flex h-16 items-end justify-around bg-pmdf-primary px-2 pb-safe md:hidden border-t border-white/20"
  >
    @for (item of items(); track item.label) {
      <app-navigation-item
        [item]="item"
        (actionTriggered)="onNavAction($event)"
      />
    }
  </nav>
}
